export default __webpack_public_path__ + "static/media/Web_07-01.22c47f92.png";